import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { LnpDataPoint } from "./types";
import UmapVisualization from "./umapVisualization";

interface GeneralOverviewProps {
  data: Array<{
    name: string;
    "Unique Ionizable Lipids": number;
    Formulations: number;
  }>;
  lnpData: LnpDataPoint[];
}

interface CustomXAxisTickProps {
  x: number;
  y: number;
  payload: {
    value: string | number;
    index?: number;
    offset?: number;
    tickCoord?: number;
    isShow?: boolean;
  };
  visibleTicksCount?: number;
  tickFormatter?: (value: any) => string;
  verticalAnchor?: string;
  textAnchor?: string;
}

const renderCustomAxisTick = (props: CustomXAxisTickProps) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-45)"
        style={{ fontSize: "12px" }}
      >
        {payload.value}
      </text>
    </g>
  );
};

const GeneralOverviewSection: React.FC<GeneralOverviewProps> = ({
  data,
  lnpData,
}) => {
  return (
    <div className="mb-6">
      <div className="bg-white rounded shadow">
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">
            Libraries Overview
          </h2>
        </div>

        <div>
          <UmapVisualization data={lnpData} />
        </div>
        <div className="h-96">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              layout="horizontal"
              margin={{ top: 20, right: 30, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <YAxis type="number" />
              <XAxis
                dataKey="name"
                type="category"
                width={100}
                height={75}
                tick={renderCustomAxisTick}
                interval={0}
              />
              <Tooltip />
              <Legend />
              <Bar dataKey="Unique Ionizable Lipids" fill="#0088FE" />
              <Bar dataKey="Formulations" fill="#00C49F" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default GeneralOverviewSection;
